import { isNonProductionHostname } from './environment';

/**
 * Preview-chrome guard.
 *
 * The configuration rail is allowed only on an explicitly approved
 * development, UAT, or review hostname. Every production or unknown hostname
 * fails closed.
 */
export const isStagingOrDev =
  typeof window !== 'undefined' &&
  isNonProductionHostname(window.location.hostname);
